export function shouldRegenerateNestedContentBoxIds(box = {}) {
  return Array.isArray(box?.content) && (box.multiBox || box.carousel);
}

export function regenerateNestedContentBoxIds(box = {}, createId) {
  if (!shouldRegenerateNestedContentBoxIds(box) || typeof createId !== "function") {
    return box;
  }

  return {
    ...box,
    content: box.content.map((item) => ({
      ...item,
      contentBoxId: createId(),
    })),
  };
}
